/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Brand-video': {
    width: 20,
    height: 14,
    viewBox: '0 0 20 14',
    data: '<path pid="0" d="M15.417 5.375V1.583C15.417.988 14.929.5 14.333.5h-13C.738.5.25.988.25 1.583v10.834c0 .595.488 1.083 1.083 1.083h13c.596 0 1.084-.488 1.084-1.083V8.625l4.333 4.333V1.042l-4.333 4.333z" _fill="#00204D"/>'
  }
})
